<template>
  <splash>
    <template v-slot:splash-content>
      <v-container fill-height fluid>
        <v-row align="center" justify="center">
          <v-col>
            <v-card flat class="py-20">
              <v-card-text class="display-1">Oops - that {{rowType}} no longer exists</v-card-text>
              <v-card-text>Please try your search again</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </splash>
</template>
<script>
import splash from "@/components/Splash";
export default {
  props: {
    rowType: String
  },
  components: {
    splash
  }
};
</script>